import { Injectable } from "@angular/core";
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
//import { AuthenticationService } from './authentication.service';


@Injectable({ providedIn: "root" })
export class AuthGuard  {
  constructor(
    private router: Router,
  //  private authenticationService: AuthenticationService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const currentUser =  JSON.parse(sessionStorage.getItem('userInfo'));
    if (currentUser) {
        if (route.data.roles) {
          var res = route.data.roles.filter(function(v) { // iterate over the array
            return currentUser.roles.indexOf(v) > -1;
          })
          if(res.length >0){
              return true;
          } else{
           // this.router.navigate(["404"]);
            return true;
          }
        }
      // authorised so return true
      return true;
    }

    // not logged in
    this.router.navigate(["/login"]);
    return false;
  }
}


